import { TEST_TYPES } from '@hawkindynamics/core-client';

interface IPhase {
  color: {
    light: string;
    dark: string;
  };
  start: string;
  end: string;
}

export const testPhases: { [key: string]: { [key: string]: IPhase } } = {
  '7nNduHeM5zETPjHxvm7s': {
    // CMJ
    Unweighting: {
      color: {
        light: 'var(--color-material-500-yellow)',
        dark: 'var(--color-material-500-yellow)',
      },
      start: 't3',
      end: 't4',
    },

    Braking: {
      color: {
        light: 'var(--color-material-500-deep-orange)',
        dark: 'var(--color-material-500-deep-orange)',
      },
      start: 't4',
      end: 't5',
    },
    Propulsive: {
      color: {
        light: 'var(--color-material-500-green)',
        dark: 'var(--color-material-500-green)',
      },
      start: 't5',
      end: 't6',
    },
  },
  QEG7m7DhYsD6BrcQ8pic: {
    // Squat
    Propulsive: {
      color: {
        light: 'var(--color-material-500-green)',
        dark: 'var(--color-material-500-green)',
      },
      start: 't3',
      end: 't4',
    },
  },
  gyBETpRXpdr63Ab2E0V8: {
    // Drop Jump
    Braking: {
      color: {
        light: 'var(--color-material-500-deep-orange)',
        dark: 'var(--color-material-500-deep-orange)',
      },
      start: 't1',
      end: 't2',
    },
    Propulsive: {
      color: {
        light: 'var(--color-material-500-green)',
        dark: 'var(--color-material-500-green)',
      },
      start: 't2',
      end: 't3',
    },
  },
  rKgI4y3ItTAzUekTUpvR: {
    // Drop Landing
    Impact: {
      color: { light: '#F15D5E', dark: '#F15D5E' },
      start: 't1',
      end: 't2',
    },
    Stabilization: {
      color: { light: '#35BDB2', dark: '#35BDB2' },
      start: 't2',
      end: 't3',
    },
  },
  pqgf2TPUOQOQs6r0HQWb: {
    // CMJ Rebound
    Unweighting: {
      color: {
        light: 'var(--color-material-500-yellow)',
        dark: 'var(--color-material-500-yellow)',
      },
      start: 't3',
      end: 't4',
    },
    Braking: {
      color: {
        light: 'var(--color-material-500-deep-orange)',
        dark: 'var(--color-material-500-deep-orange)',
      },
      start: 't4',
      end: 't5',
    },
    Propulsive: {
      color: {
        light: 'var(--color-material-500-green)',
        dark: 'var(--color-material-500-green)',
      },
      start: 't5',
      end: 't6',
    },
    ['Rebound Braking']: {
      color: {
        light: 'var(--color-material-500-pink)',
        dark: 'var(--color-material-500-pink)',
      },
      start: 't7',
      end: 't8',
    },
    ['Rebound Propulsive']: {
      color: {
        light: 'var(--color-material-500-lime)',
        dark: 'var(--color-material-500-lime)',
      },
      start: 't8',
      end: 't9',
    },
  },
  [TEST_TYPES.TS_FREE.id]: {
    ['Force Onset']: {
      color: {
        light: 'var(--color-material-500-blue-gray)',
        dark: 'var(--color-material-500-blue-gray)',
      },
      start: 't1',
      end: 't2',
    },
  },
  [TEST_TYPES.TS_ISO.id]: {
    ['Force Onset']: {
      color: {
        light: 'var(--color-material-500-blue-gray)',
        dark: 'var(--color-material-500-blue-gray)',
      },
      start: 't1',
      end: 't2',
    },
  },
};
